import { useCallback } from 'react';
import useLatest from './use-latest';
export default function useHandler(callback) {
  var handleRef = useLatest(callback);
  return useCallback(function () {
    if (typeof handleRef.current === 'function') {
      return handleRef.current.apply(handleRef, arguments);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
}